// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5004) return "static/chunks/70e0d97a-6e85c1c07061b616.js";
	if (chunkId === 277) return "static/chunks/54a60aa6-9e229b51fb4d4f4b.js";
	if (chunkId === 8875) return "static/chunks/8875-95b8a0ce915bb437.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6987":"ede3db662510e61e","7074":"e99c2e599398ce59","7744":"c50219e904ec35b1"}[chunkId] + ".js";
};